import { render } from "./GroupsAddSettings.vue?vue&type=template&id=5255db48&scoped=true&ts=true"
import script from "./GroupsAddSettings.vue?vue&type=script&lang=ts"
export * from "./GroupsAddSettings.vue?vue&type=script&lang=ts"

import "./GroupsAddSettings.vue?vue&type=style&index=0&id=5255db48&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5255db48"]])

export default __exports__